export class CreditFormConfiguration {
    public organizationUrl: string;
    public creatUrl: string;
    public formGuid: string;

    constructor(private container: JQuery) {
        this.organizationUrl = container.attr('data-organization-url');
        this.creatUrl = container.attr('data-create-api-url');
        this.formGuid = container.attr('data-form-guid');
    }
}
